import { cn } from '@/lib/cn.ts';

type Props = {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  icon?: React.ReactNode;
  accent?: 'crimson' | 'gold' | 'success' | 'none';
  className?: string;
};

const ACCENT_BAR: Record<NonNullable<Props['accent']>, string> = {
  crimson: 'before:bg-accent',
  gold: 'before:bg-gold',
  success: 'before:bg-success',
  none: 'before:bg-transparent',
};

export function StatTile({ label, value, sub, icon, accent = 'none', className }: Props) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-lg border border-border bg-bg-elevated px-4 py-3.5',
        'shadow-[inset_0_1px_0_rgba(255,255,255,0.02)]',
        'before:absolute before:inset-y-0 before:left-0 before:w-[2px] before:content-[""]',
        ACCENT_BAR[accent],
        className,
      )}
    >
      <div className="flex items-center justify-between">
        <span className="text-[10px] uppercase tracking-wider text-text-faint">{label}</span>
        {icon && <span className="text-text-faint">{icon}</span>}
      </div>
      <div className="mt-1.5 font-display text-3xl leading-none tracking-tight tnum">{value}</div>
      {sub && <div className="mt-1.5 text-[11px] text-text-faint">{sub}</div>}
    </div>
  );
}
